import { QuizQuestion } from "../../shared/types";
import {
  Speed,
  BusinessCenter,
  Code,
  DataObject,
  LocalActivity,
  Analytics,
  Dashboard,
  AutoAwesome,
  Person,
  Groups,
  Business,
  LocationCity,
  AttachMoney,
  CreditCard,
  Diamond,
  TrendingDown,
  Assessment,
  Timeline,
  Notifications,
  BarChart,
  PieChart,
  Email,
  Computer,
  Build,
  SmartToy,
  TrendingUp,
  Warning,
  Settings,
  Visibility,
  Schedule,
  SyncAlt,
  ShoppingCart,
  Inventory,
  WebAsset,
  AccountBalance,
  Warehouse,
  CheckCircle,
  Error,
  Security,
  CloudSync,
  IntegrationInstructions,
} from "@mui/icons-material";

export const integrationQuestions: QuizQuestion[] = [
  {
    question: "What's your top goal for connecting your systems?",
    options: [
      { text: "Automatically syncing customer info", icon: SyncAlt },
      { text: "Sharing order or inventory details smoothly", icon: ShoppingCart },
      { text: "Getting real-time alerts and dashboards", icon: Dashboard },
      { text: "Reducing manual data entry", icon: DataObject },
    ],
  },
  {
    question: "Which kind of data transfer matters most to you?",
    options: [
      { text: "Daily or scheduled batches (e.g., once a day)", icon: Schedule },
      { text: "Instant updates when things change", icon: Speed },
      { text: "Periodic reports (e.g., weekly or monthly)", icon: Assessment },
      { text: "Custom timing (e.g., every Friday)", icon: Settings },
    ],
  },
  {
    question: "Which systems do you want to connect first?",
    options: [
      { text: "Your website or app + CRM", icon: WebAsset },
      { text: "Sales system (like POS or e-commerce) + accounting", icon: AccountBalance },
      { text: "Inventory or warehouse system + order", icon: Warehouse },
      { text: "Any other tools you use together", icon: IntegrationInstructions },
    ],
  },
  {
    question: "How important is it that your systems 'talk' to each other automatically?",
    options: [
      { text: "Very—no manual effort at all", icon: AutoAwesome },
      { text: "Some manual work is okay", icon: Computer },
      { text: "Only automatic during business hours", icon: Schedule },
      { text: "We'd prefer a mix—manual and automatic", icon: Settings },
    ],
  },
  {
    question: "If something goes wrong, how would you like to be alerted?",
    options: [
      { text: "Instant notification (email or text)", icon: Notifications },
      { text: "Daily summary report", icon: Assessment },
      { text: "We'll check manually when we notice issues", icon: Visibility },
      { text: "No preferences", icon: TrendingDown },
    ],
  },
  {
    question: "How often do you update or change your systems?",
    options: [
      { text: "Rarely—once or twice a year", icon: TrendingDown },
      { text: "A few times a year", icon: Assessment },
      { text: "Monthly or quarterly", icon: Schedule },
      { text: "Constantly—frequently updating or changing", icon: Speed },
    ],
  },
  {
    question: "What matters more: ease of use or flexibility in your setup?",
    options: [
      { text: "Ease of use—simple and clear", icon: CheckCircle },
      { text: "A bit flexible—but still easy", icon: Settings },
      { text: "Highly flexible—even if slightly complex", icon: Code },
      { text: "We need expert-level flexibility", icon: Build },
    ],
  },
  {
    question: "What's your biggest concern about connecting systems?",
    options: [
      { text: "Data mix-ups or mistakes", icon: Error },
      { text: "Systems slowing down", icon: Speed },
      { text: "Cost of setup and upkeep", icon: AttachMoney },
      { text: "Needing technical help each time", icon: Build },
    ],
  },
  {
    question: "How soon do you want your connectivity set up?",
    options: [
      { text: "Within a week", icon: Speed },
      { text: "In 2-4 weeks", icon: Timeline },
      { text: "In a few months", icon: Schedule },
      { text: "No hurry—flexible timing", icon: TrendingDown },
    ],
  },
];